module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Footer/images/button_top.ce8d15a5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Footer/images/button_top.png
// module id = 3453
// module chunks = 11